export default {
  name: 'mgmt',
  platforms: {
    aspNet: {
      title: '.NET',
      name: 'aspnet',
      sdk: {
        name: 'auth0.net',
        url: 'https://github.com/auth0/auth0.net',
        logo: 'dotnet'
      }
    },
    java: {
      title: 'Java',
      name: 'java',
      sdk: {
        name: 'Auth0 Java',
        url: 'https://github.com/auth0/auth0-java',
        logo: 'java'
      }
    },
    nodejs: {
      title: 'Node.js',
      name: 'node',
      sdk: {
        name: 'node-auth0',
        url: 'https://github.com/auth0/node-auth0',
        logo: 'nodejs'
      }
    },
    php: {
      title: 'PHP',
      name: 'php',
      sdk: {
        name: 'auth0-PHP',
        url: 'https://github.com/auth0/auth0-PHP',
        logo: 'php'
      }
    },
    python: {
      title: 'Python',
      name: 'python',
      sdk: {
        name: 'auth0-python',
        url: 'https://github.com/auth0/auth0-python',
        logo: 'python'
      }
    },
    ruby: {
      title: 'Ruby',
      name: 'ruby',
      sdk: {
        name: 'ruby-auth0',
        url: 'https://github.com/auth0/ruby-auth0',
        logo: 'ruby'
      }
    }
  }
};
